import { createAction } from 'redux-actions';

export const GetListSeminarRequested = createAction('GET_LIST_SEMINAR_REQUESTED');
export const GetListSeminarRequestedReceived = createAction('GET_LIST_SEMINAR_REQUESTED_RECEIVED');
export const GetListSeminarRequestedReceivedFailure = createAction('GET_LIST_SEMINAR_REQUESTED_RECEIVED_FAILURE');
export const ClearListSeminar = createAction('CLEAR_LIST_EVENT_OF_SEMINAR');

export const UpdateSeminarRequested = createAction('UPDATE_SEMINAR_REQUESTED');
export const UpdateSeminarRequestedReceived = createAction('UPDATE_SEMINAR_REQUESTED_RECEIVED');
export const UpdateSeminarRequestedReceivedFailure = createAction('UPDATE_SEMINAR_REQUESTED_RECEIVED_FAILURE');
export const ClearUpdateSeminar = createAction('CLEAR_UPDATE_SEMINAR');

export const GetDetailSeminarRequested = createAction('GET_DETAIL_SEMINAR_REQUESTED');
export const GetDetailSeminarRequestedReceived = createAction('GET_DETAIL_SEMINAR_REQUESTED_RECEIVED');
export const GetDetailSeminarRequestedReceivedFailure = createAction('GET_DETAIL_SEMINAR_REQUESTED_RECEIVED_FAILURE');
export const ClearDetailSeminar = createAction('CLEAR_DETAIL_SEMINAR');

export const UpdateSeminarProgess = createAction('UPDATE_SEMINAR_PROGESS');
